import React from 'react';
import GameQuery from '../../query/GameQuery';
import SalesProgram from '../../components/SalesProgram';
import { Route } from 'react-router-dom';
import { SALESPROGRAM } from '../../routes';

const SalesProgramRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={SALESPROGRAM}
				render={props => <SalesProgram {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default SalesProgramRoute;
